import "./styles.scss";

import { useTranslation } from "react-i18next";

import { Text, Button } from "@fragments";
import { TimeSeriesChart } from "@charts";
import {
  IconChartHistogram,
  IconArrowUpRight,
  IconCash,
} from "@tabler/icons-react";

/**
 * §6.11 — community revenue around the mentoring. A neutral promo card linking
 * to the full /insights page (filters prefilled) sits above a monthly revenue
 * chart that marks the month the mentoring started with a vertical indicator.
 */
export default function RevenueSection({
  revenue,
  loading,
  communityName,
  startDateLabel,
  referenceDate,
  onOpenInsights,
}) {
  const { t } = useTranslation("member");

  return (
    <section className="cm-revenue">
      {/* Neutral link card — surface-elevation only, no primary fills. */}
      <div className="cm-revenue-promo">
        <div className="cm-revenue-promo-main">
          <span className="cm-revenue-promo-icon">
            <IconChartHistogram size={20} />
          </span>
          <div className="cm-revenue-promo-text">
            <Text.h5 contrast={8} weight={500}>
              {t("revenue.promoTitle", { community: communityName })}
            </Text.h5>
          </div>
          <Button
            text={t("revenue.openInsights")}
            endIcon={<IconArrowUpRight />}
            color="inverse"
            highlightColor="current"
            onClick={onOpenInsights}
            preventLoading
          />
        </div>

        {/* Monthly revenue with the "Início da mentoria" reference line. */}
        <TimeSeriesChart
          title={t("revenue.chartTitle")}
          icon={<IconCash size={15} />}
          timeSeries={revenue}
          valueType="money"
          defaultMode="bar"
          report={revenue}
          reportLoading={loading}
          referenceLine={
            referenceDate
              ? {
                  date: referenceDate,
                  label: t("revenue.referenceLine", { date: startDateLabel }),
                }
              : undefined
          }
        />
      </div>
    </section>
  );
}
